//#region src/domain/modal-view/modal-view.ts
var AnchorType = /* @__PURE__ */ function(AnchorType) {
	AnchorType["BOTTOM_LEFT"] = "bl";
	AnchorType["BOTTOM_RIGHT"] = "br";
	AnchorType["CENTER"] = "c";
	AnchorType["TOP_LEFT"] = "tl";
	AnchorType["TOP_RIGHT"] = "tr";
	AnchorType["VERTICAL_LEFT"] = "vl";
	AnchorType["VERTICAL_RIGHT"] = "vr";
	return AnchorType;
}({});
//#endregion
export { AnchorType };

//# sourceMappingURL=modal-view.js.map